/* eslint-disable no-undef */
import { Input, Modal, Row, Col, message, Form } from "antd";
import React, { Component } from "react";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import "./SystemConfig.css";
import { SystemConfigService } from "../../services/systemConfig/SystemConfigService";
import "antd/dist/antd.css";
import { handleError } from "../../utils/ErrorHandlers";
import "../../components/general/drawer/AdaptiveDrawer.css";

class AddConfig extends Component {
  constructor(props) {
    super(props);
    this.systemConfigService = new SystemConfigService();
    this.state = {
      isFetchingAdd: false,
      visible: false,
      key: "",
      value: "",
      configCategory: ""
    };
  }

  handleCancel = e => {
    this.setState({
      visible: false
    });
  };

  validateValue(text) {
    this.setState({ value: text });
  }

  validateKey(text) {
    this.setState({ key: text });
  }

  validateConfigCategory(text) {
    this.setState({ configCategory: text });
  }

  componentDidMount() {}

  async addSystemConfig(config) {
    try {
      this.setState({ isFetchingAdd: true });
      let data = await this.systemConfigService.addSystemConfigService(
        this.props.context.session_id,
        {
          key: config.Key,
          value: config.value,
          configCategory: config.configCategory
        }
      );
      this.setState({ isFetchingAdd: false });

      this.props.onCancel();
      this.props.getAllSystemConfigs();
      message.success("System Config added successfully");
    } catch (e) {
      this.setState({ isFetchingAdd: false });
      handleError(e);
    }
  }

  handleOk = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ isFetchingAdd: true });

          await this.addSystemConfig(values);
        }
      } catch (e) {
        this.setState({ isFetchingAdd: false, visible: false });
        handleError(e);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      wrapperCol: {
        xs: { span: 20 },
        sm: { span: 12 }
      }
    };

    return (
      <Modal
        destroyOnClose={true}
        title="Add Configuration"
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={() => this.props.onCancel()}
        okText={t("OK")}
        cancelText={t("Cancel")}
      >
        <Form {...formItemLayout}>
          <Form.Item label="Key">
            {getFieldDecorator("key", {
              rules: [
                {
                  type: "string",
                  message: "The input is not valid ",
                },
                {
                  required: true,
                  message: "Please enter configuration key",
                },
              ],
            })(<Input />)}
          </Form.Item>

          <Form.Item label="Value">
            {getFieldDecorator("value", {
              rules: [
                {
                  type: "string",
                  message: "The input is not valid ",
                },
                {
                  required: true,
                  message: "Please enter configuration value",
                },
              ],
            })(<Input />)}
          </Form.Item>

          <Form.Item label="Configuration Category">
            {getFieldDecorator("configCategory", {
              rules: [
                {
                  message: "The input is not valid ",
                },
                {
                  required: true,
                  message: "Please enter Configuration Category",
                },
              ],
            })(<Input />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(withSharedStateConsumer(AddConfig));
